import { useBatchCheckpointsScanner } from '@/pages/Business/pages/BatchCheckpoints/hooks';
import { useGetExternalOperatorBatchTransitionsQuery } from '../../services/externalOperatorBatchTransitions.endpoints';

export const useExternalOperatorBatchCheckpointsScanner = () =>
  useBatchCheckpointsScanner({
    useTransitionsQuery: useGetExternalOperatorBatchTransitionsQuery,
  });
